import { useCheckoutContext } from '@/context/CheckoutContext/CheckoutContext';
import SummarySkeleton from '../Skeletons/SummarySkeleton';
import { SplitSummary } from './SplitSummary/SplitSummary';
import { Summary } from './Summary';

interface Props {
  isLoading: boolean;
  serviceFee?: number;
  grossDiscount: number;
  isSplitExist: boolean;
  openServiceFeeInfo: () => void;
  orderNumber: string;
}

export const SummaryController = ({
  serviceFee,
  grossDiscount,
  isLoading,
  isSplitExist,
  orderNumber,
  openServiceFeeInfo,
}: Props) => {
  const { state } = useCheckoutContext();
  const { baseToPay, selectedTipPercentage, customTipAmount } = state;

  const commonProps = {
    haveToShowCashbackBanner: true,
    isLoading,
    serviceFee,
    grossDiscount,
    baseToPay,
    onToggleServiceFeeInfo: openServiceFeeInfo,
    tipPercentage: selectedTipPercentage,
    customTipAmount,
  };

  if (isLoading) {
    return <SummarySkeleton />;
  }

  if (isSplitExist) {
    return (
      <SplitSummary
        {...commonProps}
        orderNumber={orderNumber}
        key={`${baseToPay}-${selectedTipPercentage}-${customTipAmount}`}
      />
    );
  }

  return (
    <Summary {...commonProps} key={`${baseToPay}-${selectedTipPercentage}-${customTipAmount}`} />
  );
};
